import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Snackbar,
  Alert,
  Box,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React, { useState } from 'react';
import Header from '../Header/Header';
import AssetSync from './AssetSync';
import StandardSetSync from './StandardSetSync';
import { getStyles } from './styles';

enum SyncType {
  Asset = 'asset',
  StandardSet = 'standardSet',
}

const defaultSyncType = SyncType.Asset;

export default function Standards() {
  const [syncType, setSyncType] = useState(defaultSyncType);
  const [isSuccess, setIsSuccess] = useState(false);

  const theme = useTheme();
  const styles = getStyles(theme);

  const handleClose = () => {
    setIsSuccess(false);
    setSyncType(defaultSyncType);
  };

  return (
    <>
      <Header />
      <Box sx={styles.root}>
        <h1>Correlation Complete</h1>
        <h4>
          This page allows you to tell us when either a single Beable asset is
          aligned and ready to have its standards fetched or whether a standard
          set for a state needs to be updated.
        </h4>
        <FormControl fullWidth>
          <InputLabel id='sync-type-select-label'>Sync Type</InputLabel>
          <Select
            labelId='sync-type-select-label'
            value={syncType || ''}
            label='Sync Type'
            onChange={(e) => {
              setSyncType(e.target.value as SyncType);
            }}
          >
            <MenuItem value={SyncType.Asset}>Asset</MenuItem>
            <MenuItem value={SyncType.StandardSet}>Standard Set</MenuItem>
          </Select>
        </FormControl>
        {syncType === SyncType.Asset && (
          <AssetSync onSuccess={() => setIsSuccess(true)} />
        )}
        {syncType === SyncType.StandardSet && (
          <StandardSetSync onSuccess={() => setIsSuccess(true)} />
        )}
        <Snackbar
          open={isSuccess}
          autoHideDuration={6000}
          onClose={(_event, reason) => {
            if (reason === 'clickaway') {
              return;
            }
            handleClose();
          }}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        >
          <Alert onClose={handleClose} severity='success'>
            Your sync request was submitted!
          </Alert>
        </Snackbar>
      </Box>
    </>
  );
}
